import React from 'react';
import i18n from "i18next";
import { connect } from 'react-redux'
import { List, Tooltip, Button, Modal, message } from 'antd';
import { CloseOutlined, EditOutlined, ExclamationOutlined } from '@ant-design/icons'
import { subsetByLang, getValues, getValuesAsIs } from '../../virtuoso/helper';
import { AdmsRepository, AdmsAsset, RdfTriplet } from '../../redux';
import { ADMSRDF } from '../../const/C';
import ConceptScheme from './ConceptScheme';

const { confirm } = Modal;

/** Формирует последовательность таксономии. 
 * Ищет в концептах схему, которая должна быть назначена 
 */
const sortConcepts = concepts => {
  let j = 0;
  for (let i = 0; i < ADMSRDF.TAXONOMY_SEQUENCE.length; i++) {
      const IRI = ADMSRDF.TAXONOMY_SEQUENCE[i];
      //Может отсутствовать назначение концепта из списка схем
      //console.log("TaxonomyValues.js sortConcepts", IRI, concepts);
      const pos = concepts.map(item => item.inScheme).indexOf(IRI);
      if (pos<0) {
        console.warn("Taxonomy for scheme ",IRI, " not set. Concepts -", concepts);
        continue;
      }
      if (j==pos) {j++ ; continue};
      if (j>=(concepts.length-1)) break;
      [concepts[pos], concepts[j]] = [concepts[j], concepts[pos]];
      j++;
  }
  return concepts;
}

/** Формирование элемента отображение классификации */
const ListItem = ({item, operation, taxonomy, onAction=f>f}) => {
  const notInTheme = (operation=='edit') && taxonomy.filter(scheme => scheme.IRI.value == item.inScheme && scheme.context == 'THEME').length<1 ;
  const actions= (operation=='edit')?
  [
    <span style={{"padding":"0px"}}>
      { notInTheme &&
        <Tooltip placement="top" title={i18n.t('components.skos.taxonomyValues.deleteClassification')}><ExclamationOutlined style={{ color: 'red' }} />
          <Button size="small" icon={<CloseOutlined />} onClick={(e)=> onAction(e, "delete", item)}/>
        </Tooltip>
      }
      <Tooltip placement="top" title={i18n.t('components.skos.taxonomyValues.editClassification')}>{item.iri==undefined && <ExclamationOutlined style={{ color: 'red' }} />}
        <Button size="small" icon={<EditOutlined />} onClick={(e)=> onAction(e, "edit", item)} />
      </Tooltip>
    </span>
  ]:[];

  return (
    <List.Item actions={actions}>
      <List.Item.Meta 
        title={<span className="csi_cat_title">{item.scheme}</span>}
        description={item.concept}
      />
    </List.Item>
  )  
}

/** Отображение диалога с выбором концепта для установки связи.
 * selected - URI выбранного элемента
 */
const showSelectConcept = (schema, formRef=f=>f, factory, onFinishOperation=f=>f, onCancelOperation=f=>f, selected,
  onChangeConcept=f=>f
) => {
  //console.log("ObjectPropertyEditor.js showSelectConceptScheme", schema, selected);
  const isURI = (selected) && Array.isArray(selected) && selected.length>0;
  const okButtonProps={disabled: !isURI};
  return (
    <Modal 
      style={{minWidth: 700}} open={true}
      title={i18n.t('components.editor.individual.select.title')}
      cancelText={i18n.t('components.editor.individual.select.cancelText')} 
      okText={i18n.t('components.editor.individual.select.okText')} 
      onCancel={onCancelOperation} 
      onOk={onFinishOperation} 
      okButtonProps={okButtonProps}>	
        <ConceptScheme           
          view='single'
          schema={schema}
          expand={true}
          hideStatistics={true}
          hasCheck={selected}
          onChange={onChangeConcept}
        />
	  </Modal>
    )
}

const filterNewScheme = (concepts, taxonomy) =>{
  return taxonomy
    .filter(item => item.context == 'THEME')
    .filter(item => concepts.filter(concept => concept.inScheme == item.IRI.value).length==0)
}

const makeSchemaName = (taxonomy, schemaIRI, lang, info) => {
  const schemeItems = (Array.isArray(taxonomy))?taxonomy.filter(item => item.IRI && (item.IRI.value==schemaIRI)):null;
  const schemaLabels = (Array.isArray(schemeItems)&&(schemeItems.length>0)&& schemeItems[0].schema)? subsetByLang(schemeItems[0].schema, lang, "label"):[];
  return  (schemaLabels.length>0)?schemaLabels[0].label.value: i18n.t('components.skos.taxonomyValues.schemeMissing', { info });
}
/** Отображение таксономии.  Для отображения используется List (см. https://ant.design/components/list/), который содержит:
 * 1. Заголовок - название таксономии (наименование КонцептСхемы). 
 * 2. Тело - значение (наименование концепта)
 * 3. Входным прараметром является URI предиката, который содержит объекты (object, обычно IRI) значений.
 * Для SKOS это индивидуалы skos:Concept 
 * 
 * При получении URI предиката, подучаем список IRI, которые содержат значения таксономии (для SKOS это skos:Concept)
 * 
 * */
class TaxonomyValuesCard extends React.Component {
  state = {
    loading: false,
    concepts: [],
    selectInScheme: undefined,  //URI схемы, для которой необходимо выбрать концепт. Если задано вызывается модальное окно
    checkedConcepts:[]          //Список концептов, выделенных в схеме. Для модификации)
  }
  
  componentDidMount() {
    this.loadTaxonomyValues();
  }

  componentWillReceiveProps(nextProps){
    const {predicat, operation} = nextProps;
    if (this.state.predicat!=predicat)
      this.loadTaxonomyValues();
    if (this.state.operation != operation && operation=='edit')
      this.loadThemeTaxonomyValues();
  }

  loadTaxonomyValues() {
    const {predicat, values, taxonomy, lang, graph, onLoadTaxonomy} = this.props;
    this.setState({loading: true, predicat});
    //Получаем список ссылок
    const data = getValuesAsIs(predicat, lang, values);
    const concepts = data.map(iri => {
      return {concept: iri, scheme: iri};
    })
    this.setState({concepts});
    const result = data.map(iri => RdfTriplet.loadSubject(iri));
    //Надо проверить, что загружено описание схем
    // const schemas = taxonomy.filter(item => ( typeof item.state == 'undefined') || (item.state != "loaded"))
    //   .map(item => this.props.dispatch(AdmsRepository.loadTaxonomy(item.IRI.value)));
    //console.log("TaxonomyValues.js loadTaxonomyValues()", taxonomy, schemas);

    Promise.all(result)
      .then(result => {
        //console.log("RdfAction.loadSubject", result);
        const data = result.map(concept => {
          const label = getValues("http://www.w3.org/2000/01/rdf-schema#label", lang, concept.bindings);
          const getIRI = getValues("http://www.w3.org/2004/02/skos/core#inScheme", lang, concept.bindings);
          const schemaIRI = (getIRI)? getIRI: null;
          const scheme = makeSchemaName(taxonomy, schemaIRI, lang, concept.subject);
          //console.log("TaxonomyValues.js loadTaxonomyValues() => !!!!!!", concept, label, scheme);
          const schemeItems = (Array.isArray(taxonomy))?taxonomy.filter(item => item.IRI && (item.IRI.value==schemaIRI)):null;
          const schemaLabels = (Array.isArray(schemeItems)&&(schemeItems.length>0)&& schemeItems[0].schema)? subsetByLang(schemeItems[0].schema, lang, "label"):[];
          return {iri: concept.subject, concept: label, scheme, inScheme: getIRI, isSchemeLabel: schemaLabels.length>0};
        });
        //Надо отсортировать концепты в соответствии со схемой 
        //console.log("TaxonomyValues.js loadTaxonomyValues()", data, result);
        this.setState({concepts: sortConcepts(data), loading: false});
        return {concepts: data, loading: false};
      })
      .then(data => {
        //Обработаем возможную дозагрузку схемы
        const schemas = data.concepts.filter(
            item => !item.isSchemeLabel
          ).map(
            item => onLoadTaxonomy(item.inScheme)              
          );
        if (schemas.length>0){
            Promise.all(schemas).then(result => {
              const items =  data.concepts.map(concept => {
                const scheme = makeSchemaName(this.props.taxonomy, concept.inScheme, lang, concept.iri);
                return Object.assign({},concept, {scheme});
              })
            this.setState({concepts: sortConcepts(items), loading: false});
          });
        };
      });
  };
  
  /** Загрузка таксономии каталога */ 
  loadThemeTaxonomyValues() {
    const {predicat, values, taxonomy, lang, graph, onLoadTaxonomy} = this.props;
    //Дозагрузим содeржимое схемы для случая, если схема добавлена, а описания нет (для режима редактирования)
    const newSchemas = taxonomy.filter(
      scheme => scheme.context == 'THEME' && scheme.state != "loaded"
    ).map(
      scheme => onLoadTaxonomy(scheme.IRI.value)              
    );
    if (newSchemas.length>0){
      this.setState({loading: true, operation: 'edit'});
      Promise.all(newSchemas).then(result => {
        this.setState({loading: false});
      })
    };  
  };
    
  onAction(e, type, item){
    //console.log("TaxonomyValues.js onAction", type, item);
    e.preventDefault();
    if (type=="edit"){
      const { concepts } = this.state;
      const checkedConcepts = (concepts)?concepts.filter(concept => concept.inScheme == item.inScheme):[];
      this.setState({selectInScheme: item.inScheme, checkedConcepts});
      return;
    };
    if (type=="delete"){
      const {subject, predicat, onDeleteValue, onReload, graph} = this.props;
      const reloadTaxonomyValues = () => this.loadTaxonomyValues();
      confirm({
        title: i18n.t('components.skos.taxonomyValues.deleteConfirmation'),
        content: item.iri,
        okText: i18n.t('components.skos.taxonomyValues.yes'),
        okType: 'danger',
        cancelText: i18n.t('components.skos.taxonomyValues.no'),
        onOk() {
          console.log('OK', subject , predicat, item);
          onDeleteValue(subject, predicat, item.iri)
          .then (result =>{
            //Обновим карточку
            if (onReload)
              onReload(subject, graph).then(result2=> {
                reloadTaxonomyValues();
              });
            else  
              message.success(i18n.t('components.skos.taxonomyValues.reloadToViewChanges'));
            })
          .catch(info => {
            message.error(i18n.t('components.editor.individual.message.e_unlink', {detail: info}));
          });
        },
        onCancel() {
            //this.setState({selected: predicat, operation: "view"})
        },
      });
    return;
    };
  };

  cancelOperation(){
    this.setState({selectInScheme: undefined, checkedConcepts:[]});
  };

  /** Получает уведомления от ConceptScheme при изменении выбора концепта */
  onChangeConcept(changed, concept){
    //console.log("TaxonomyValues.js", changed, concept);
    const {selectInScheme, checkedConcepts, concepts} = this.state;
    const newCheckedConcepts = [];
    if (changed){
      newCheckedConcepts.push({
        iri: concept.IRI.value,
        concept: "",
        scheme: "",
        inScheme: selectInScheme,
        isSchemeLabel: false
      });
    };
    this.setState({checkedConcepts: newCheckedConcepts});
  };

  /** Запускате обновление связей*/
  submitLinkOperation() {
    const {subject, predicat, onDeleteValue, onInsertValue, onReload, graph} = this.props;
    const {selectInScheme, checkedConcepts, concepts} = this.state;
    const hasConcepts = (concepts)?concepts.filter(concept => concept.inScheme == selectInScheme):[];
    //Формируем список на удаление. Те, которые есть в hasConcepts, но нет в checkedConcepts
    const forDelete = hasConcepts.filter(hasConcept => 
      checkedConcepts.filter(checkedConcept => checkedConcept.iri == hasConcept.iri).length == 0
    );
    //Формируем список на добавление. Те, которые есть в checkedConcepts, но нет в hasConcepts
    const forInsert = checkedConcepts.filter(checkedConcept => 
      hasConcepts.filter(hasConcept => hasConcept.iri == checkedConcept.iri).length == 0
    );
    //console.log("TaxonomyValues.js submitLinkOperation", this, forDelete, forInsert);
    if (forDelete.length>0 || forInsert.length>0){
    //Формируем запросы для удаления и добавления
      const requests = forDelete.map(
        item => onDeleteValue(subject, predicat, item.iri)
      );
      forInsert.forEach(
        item => requests.push(onInsertValue(subject, predicat, item.iri))
      );
      Promise.all(requests).then (result =>{
        //Обновим карточку
        //console.log("TaxonomyValues.js submitLinkOperation", this, subject, graph);
        if (onReload)
          onReload(subject, graph).then(result2=> {
            this.loadTaxonomyValues();
            message.success(i18n.t('components.editor.individual.message.ok_link'));
          });
        else {
          message.success(i18n.t('components.skos.taxonomyValues.reloadToViewChanges'));
        };
      });
    }
    this.setState({selectInScheme: undefined, checkedConcepts:[]});
  };

  render() {
    //console.log(this);
    const { loading, concepts, selectInScheme, checkedConcepts} = this.state;
    const { operation, lang, taxonomy, factory } = this.props;
    const schema = (selectInScheme)? taxonomy.filter(schema => schema.IRI.value == selectInScheme):[];
    const newSchemes = (operation=='edit')?filterNewScheme(concepts, taxonomy):[];
    const dataSource = [... concepts];
    newSchemes.map(scheme => dataSource.push({
      iri: undefined,
      concept: "",
      inScheme: scheme.IRI.value,
      isSchemeLabel: false,
      scheme: makeSchemaName(taxonomy, scheme.IRI.value, lang, "")
    }));
    //console.log(operation, newSchemes);
    return (
      <span>
        <List
          className="demo-loadmore-list"
          loading={loading}
          itemLayout="horizontal"
          dataSource={dataSource}
          renderItem={item => (
            <ListItem item={item} operation={operation} taxonomy={taxonomy} 
              onAction={(e, type, item) => this.onAction(e, type, item)}/>
          )}
        />
        {selectInScheme && schema.length>0 &&
          showSelectConcept(
            schema[0], this.formRef, factory, 
            ()=>this.submitLinkOperation(), ()=>this.cancelOperation(),
            checkedConcepts,
            (checked, concept) => this.onChangeConcept(checked, concept)
          )
        }
      </span>
    );
  }
}
  
  //Представление информации о ЕМД
export default connect(
  (state, props) => {
    const {vadms, vset, vasset} = state;
    const {lang, graph } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      taxonomy: vadms.taxonomy,
      values: vasset.values,      //Текущие данные
    })
  },
  dispatch => ({
    onReload(subject, graph){
      return dispatch(AdmsAsset.loadAsset(subject));
    },
    onLoadTaxonomy(scheme){
      return dispatch(AdmsRepository.loadTaxonomy(scheme));
    },
    onInsertValue(subject, predicat, object){
      return dispatch(RdfTriplet.insertTripleURI(subject, predicat, object));
    },
    onDeleteValue(subject, predicat, object){
      return dispatch(RdfTriplet.deleteTripleURI(subject, predicat, object));
    },
})
)(TaxonomyValuesCard)
